import React from "react";
import { ArrowRight } from "lucide-react";

export default function FeatureGridSection3() {
  return (
    <section
      id="pricing"
      className="relative isolate overflow-hidden py-20 sm:py-28 px-6 sm:px-12 bg-white"
      style={{ backgroundColor: "#ffffff" }}
    >
      {/* Soft forge wash behind the card */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 h-96 w-[42rem] opacity-15 blur-3xl"
      >
        <div className="h-full w-full rounded-full bg-gradient-to-tr from-[#7c3aed] to-[#38bdf8]" />
      </div>

      <div className="relative mx-auto max-w-4xl">
        <div
          className="relative overflow-hidden rounded-2xl bg-white border transition-shadow duration-300 shadow-sm hover:shadow-md"
          style={{ borderColor: "#e5e1ee" }}
        >
          {/* Violet hairline */}
          <div
            aria-hidden="true"
            className="h-1 bg-gradient-to-r from-[#7c3aed] via-[#8b5cf6] to-[#38bdf8]"
          />

          <div className="px-8 py-14 sm:px-16 sm:py-20 text-center">
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-balance"
              style={{ color: "#0f172a" }}
            >
              Build your ThreatForge bundle
            </h2>
            <p
              className="mt-5 mx-auto max-w-xl text-base sm:text-lg font-medium leading-relaxed"
              style={{ color: "#334155" }}
            >
              Mix modeling engines, Sentry 2.0 AI, and governance controls to match your program —
              then get a custom quote.
            </p>

            <div className="mt-9">
              <a href="/get-quote" className="tfl-btn tfl-btn--primary">
                <span>Get a Quote</span>
                <ArrowRight size={15} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
